import React, { ReactNode, forwardRef } from 'react';

import { type TooltipProps } from '@mui/material';
import { IconButton, IconButtonProps } from 'components/IconButton';

import StyleToolTipIconButton from './StyleToolTipIconButton';

interface TooltipIconButtonProps extends Omit<IconButtonProps, 'children' | 'title'> {
	tooltipProps?: Omit<TooltipProps, 'children' | 'title'>;
	children: ReactNode;
	title: TooltipProps['title'];
}

const defaultTooltipProps: Partial<TooltipProps> = {
	arrow: true,
	enterDelay: 200,
	enterTouchDelay: 0,
};

const TooltipIconButton = forwardRef<HTMLButtonElement, TooltipIconButtonProps>(
	({ tooltipProps, children, title, variant = 'contained', ...props }, ref) => (
		<StyleToolTipIconButton {...defaultTooltipProps} {...tooltipProps} title={title}>
			<IconButton ref={ref} variant={variant} {...props}>
				{children}
			</IconButton>
		</StyleToolTipIconButton>
	),
);

export default TooltipIconButton;

TooltipIconButton.displayName = 'TooltipIconButton';
